<div fxLayout="row" fxLayoutAlign="center center" fxFlex="100">
  <div class="notification-details" fxLayout="column" fxFlex="90" fxFlex.gt-md="80" fxFlex.gt-lg="70" fxLayoutGap="20">
    
    <div fxLayout="row" fxFlex="100" fxLayoutAlign="center center" fxLayoutGap="10px">
      <div fxFlex="auto" fxLayoutAlign="center">
        <mat-card-header mat-dialog-title class="title">Update Notification</mat-card-header>
      </div>
      <div fxFlex="none" fxLayoutAlign="end center">
        <button mat-icon-button class="close-icon" (click)="navigateBack()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <form fxLayout="column" fxLayoutGap="20px" fxFlex="100">
      <div *ngIf="pushData.length > 0" fxLayout="row" fxLayoutGap="10px" fxLayoutWrap>
        <div *ngFor="let push of pushData" fxFlex="100" fxFlex.gt-sm="50">
          <div fxLayout="column" fxLayoutGap="10px">
            <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
              <div fxFlex="25" class="detail-label">Language :</div>
              <div fxFlex="68">
                <input [value]="push.language" class="full-width-input" disabled />
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
              <div fxFlex="25" class="detail-label">Title :</div>
              <div fxFlex="68">
                <input [(ngModel)]="push.push_title" name="{{push.language}}Title" placeholder="Enter {{push.language}} title" class="full-width-input" />
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
              <div fxFlex="25" class="detail-label">Body :</div>
              <div fxFlex="68">
                <textarea [(ngModel)]="push.push_body" name="{{push.language}}Body" placeholder="Enter {{push.language}} body" class="full-width-input"></textarea>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
              <div fxFlex="25" class="detail-label">Redirect URL :</div>
              <div fxFlex="68">
                <input [(ngModel)]="push.redirect_url" name="{{push.language}}RedirectUrl" placeholder="Enter {{push.language}} redirect URL" class="full-width-input" />
              </div>
            </div>
          </div>
        </div>
      </div>

    <!-- <div fxFlex="100" fxFlex.gt-sm="50" fxLayout="column" fxLayoutGap="10px">
      <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
        <div fxFlex="12" class="detail-label">Status :</div>
        <div fxFlex="90">
          <input [value]="state" class="full-width-input" disabled />
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
        <div fxFlex="12" class="detail-label">Created By :</div>
        <div fxFlex="90">
          <input [value]="createdBy + ' ' + (createdTime | date:'medium')" class="full-width-input" disabled />
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
        <div fxFlex="12" class="detail-label">Updated By :</div>
        <div fxFlex="90">
          <input [value]="updatedBy + ' ' + (updatedTime | date:'medium')" class="full-width-input" disabled />
        </div>
      </div>
    </div> -->

      <div fxFlex="100" fxLayout="row">
        <div *ngIf="errorMessage" class="error-message" fxFlex="20">{{ errorMessage }}</div>

        <div fxLayout="row" fxFlex="100" fxLayoutAlign="end">
          <button mat-raised-button class="mat-button-update" (click)="update()" [disabled]="!hasChanges()">Update</button>
        </div>      
      </div>    
    </form>
  </div>
</div>
